<template>
<div class="chapter">
<div class="inner_page">
<div class="_idGenObjectStyleOverride-1">
<p class="chapter-title-break" id="_idParaDest-3"><a id="_idTOCAnchor-13"></a>Acknowledgments</p>
<p class="flush-left">First and foremost, I would like to thank our Creator God and His only son, Jesus Christ. Thank you for showing me how to live.</p>
<p class="chapter-text">I would like to thank my father, Frank Humphries, for having faith in all I do, and for the numerous times you never gave up on me.</p>
<p class="chapter-text">I wholeheartedly thank Scott and Sally Van Krevelen for saving my life. Thank you for providing hope and a home for countless alcoholics and addicts.</p>
<p class="chapter-text">Thank you to my husband, Dusty, for unconditionally loving me and never giving up on our family. I love you.</p>
<p class="chapter-text">Thank you to our awesome children for all your love and endless smiles.</p>
<p class="chapter-text">Thanks to my sponsor, Jeanie, for helping me through the steps and for being so wonderful!</p>
<p class="chapter-text">Thanks to Aunt Linda, Grandma, Brenda, Amy, my two older brothers Derrick and Chad, and the rest of my family and friends for all your love and support. You are greatly appreciated!</p>
<p class="chapter-text">A special thank you to Morgan James Publishing for believing in me.</p>
<p class="chapter-text _idGenParaOverride-1">And last but not least, I want to thank my mother who is now in heaven. I’m excited to reunite with you in the clouds some day!</p>
<p class="note">Please Note:  <br/>Some names have been changed <br/>to protect privacy.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9781630472863_EPUB-6.vue?18f713f8